/// <reference path="menu/menu.ts" />
/// <reference path="menu/header.ts" />
/// <reference path="menu/infobar.ts" />
/// <reference path="apps/appbase.ts" />
/// <reference path="../types/signalr.d.ts" />
/// <reference path="../types/jsbarcode.d.ts" />
/// <reference path="../../sp_tools/dist/sp.d.ts" />
/// <reference path="classes/AddItemAssistant.ts" />



//namespace DebugLogging {
//    export let saveLog: boolean = false;
//    export let streamLog: boolean = false;
//    export let logMessages: any[] = [];
//    var console_log = console.log;
//    var console_error = console.error;

//    export function init() {
//        console.log = function () {
//            if (saveLog) {
//                var arr = ["log", Date.now(), arguments];
//                logMessages.push(arr);
//            }

//            if (streamLog) {
//                if (TerminalApp.hub.connection.state == "Connected")
//                    TerminalApp.hub.connection.invoke("PushDebugLog", "log", arguments);
//            }

//            console_log.apply(console, arguments);
//        };

//        console.error = function () {
//            if (saveLog) {
//                var arr = ["error", Date.now(), arguments];
//                logMessages.push(arr);
//            }

//            if (streamLog) {
//                if (TerminalApp.hub.connection.state == "Connected")
//                    TerminalApp.hub.connection.invoke("PushDebugLog", "error", arguments);
//            }

//            console_error.apply(console, arguments);
//        };
//    }
//}



namespace TerminalApp {
    //vars
    export let deviceId = -1;
    export let deviceType = "";
    export let devicePrefix = "";
    export let currentUser = "";
    export let currentCustomer = "";
    export const app_constructors: { [key: string]: any } = {};
    export const apps: { [key: string]: AppBase } = {};
    export let hub: SP.SignalRConnection = new SP.SignalRConnection("/wmshub/");
    export let barcodeListener = new SP.BarcodeEngine();
    export const container = document.getElementById("terminalapp");
    export const infobar = new TerminalApp.Infobar();
    export const header = new TerminalApp.Header();
    export const menu = new TerminalApp.Menu();
    export let addItemAssistant: AddItemAssistant;
    export let itemShortcutAssistant: ItemShortcutAssistant;
    export let itemParkingAssistant: ItemParkingAssistant;
    export let placementShortcutAssistant: PlacementShortcutAssistant;
    export let placementFinderAssistant: PlacementFinderAssistant;
    export let placementPickerAssistant: PlacementPickerAssistant;
    export let toteAndPlacementPickerAssistant: ToteAndPlacementPickerAssistant;
    export let printerPickAssistant: PrinterPickAssistant;
    export let toteAssistant: ToteAssistant;
    export let itemSearchAssistant: ItemSearcherAssistant;
    export let quickAuditAssistant: QuickAuditAssistant;
    export let trolleyAssistant: TrolleyAssistant;
    export let editLotAssistant: EditLotAssistant;

    export function createListButton(className: string, text: string, action: () => void) {
        let btn = document.createElement("div");
        btn.classList.add("btn", "noselect", "list_button", className);

        let icon = btn.appendChild(document.createElement("i"));
        icon.classList.add("fas", "fa-check", "icon");

        let txt = btn.appendChild(document.createElement("span"));
        txt.classList.add("text", "big", "left");
        txt.innerHTML = text;

        btn.addEventListener("click", action);
        return btn;
    }
 
    export function normalize(number: number) {
        return parseFloat(number.toFixed(3));
    }

    export function RegisterApp(key: string, constructor: any) {
        this.app_constructors[key] = constructor;
    }

    export function GetBarcodeQty(allBarcodes: { [key: string]: number }, bc: string): number {
        if (!bc || !allBarcodes) return null;

        bc = bc.trim().replace(/^0+/, '');

        // Try accessing directly first
        let qty = allBarcodes[bc];

        // If not found, try with leading zeros
        if (qty === undefined) {
            for (let key in allBarcodes) {
                let strippedKey = key.trim().replace(/^0+/, '');
                if (strippedKey === bc) {
                    qty = allBarcodes[key];
                    break;
                }
            }
        }

        //soft match
        if (qty === undefined && App_Settings.wmsSettings.allow_soft_barcode_match) {
            for (let key in allBarcodes) {
                let strippedKey = key.trim().replace(/^0+/, '');
                if (strippedKey.includes(bc) || bc.includes(strippedKey)) {
                    qty = allBarcodes[key];
                    break;
                }
            }
        }

        // If still not found, return null
        if (qty === undefined) return null;

        return qty ? qty : 1;
    }

    let loading = false;
    let loadingScreen = document.getElementById("loading_screen");
    let loadingVideo = loadingScreen.querySelector("video") as HTMLVideoElement;
    let _loadCount = 0;
    export async function StartLoading(disableInput: boolean = true, disbleScanning: boolean = true) {
        console.log("Start");

        _loadCount++;
        loadingScreen.style.pointerEvents = disableInput ? "all" : "none";
        if (disbleScanning) barcodeListener.pause();

        if (!loading) {
            loadingVideo.play();
            loadingScreen.style.display = "flex";
            loading = true;
            //await SP.sleep(0);
            loadingScreen.style.opacity = "1";
        }
    }

    export async function StopLoading() {;
        //await SP.sleep(2);
        console.log("Stop");
        _loadCount--;
        console.log(_loadCount);
        if (!_loadCount && loading) {
            loadingVideo.pause();
            loading = false;
            barcodeListener.resume();
            loadingScreen.style.opacity = "0";
            loadingScreen.style.display = "none";
        }
    }

    export async function CloseAllApps() {
        for (let key in apps) { apps[key].close(); }
    }

    export function GetApp(key: string): AppBase {
        if (apps[key] == null) apps[key] = new app_constructors[key]();
        return apps[key];
    }

    //export async function TransferUser() {
    //    location.href = '/terminal/?handler=SignIn?transfer=' + deviceId;
    //}

    export async function LogOut() {
        var result = await SP.post("/API/FormSubmit/Login?Handler=Logout", null);
        GetApp("login").open();
        location.reload();
    }

    export function SetDevice(id: number) {
        deviceId = id;
        localStorage.setItem("wms_deviceId", id.toString());


        JsBarcode("#terminal_barcode2", devicePrefix + "_" + id, {
            width: 4,
            height: 100,
            displayValue: false
        });

        document.querySelectorAll(".terminal_name").forEach(item => item.innerHTML = deviceType + " " + id.toString());
    }


    export function start(authenticated: boolean, userId: string, _deviceType: string, _devicePrefix: string) {
        //DebugLogging.init();

        deviceType = _deviceType;
        devicePrefix = _devicePrefix;
        currentUser = userId;


        barcodeListener._startCallbacks.push(() => {
            //console.log("Start Scanning Barcode");
            SP.blurActive();
        });

        //method that will convert alternativ barcodes to stock placement scans!
        if (App_Settings.wmsSettings.use_additional_placement_barcodes) {
            var cached: any = {};
            var n = 0;
            barcodeListener._convertScanMethods.push(async (barcode) => {
                if (
                    barcode
                    && barcodeListener.hasBoundCommand("sp")
                ) {
                    //clear cache at 300
                    if (n > 300) {
                        cached = {};
                        n = 0;
                    }

                    //get from cache or add from api
                    if (cached[barcode] === undefined) {
                        cached[barcode] = await SP.get("/api/v1/info/getPlacementId/" + barcode) ?? false;
                        n++;
                    }

                    //convert to stockplacement scan
                    if (cached[barcode]) {
                        barcodeListener.performScan("sp_" + cached[barcode]);
                        return false;

                    }

                }

                return true;
            });
        }

        hub.on("ScanBarcode", async (code: string) => {
            await barcodeListener.performScan(code);
        });


        hub.on("alert", (msg: string) => {
            SP.alertX(msg);
        });

        hub.on("goToHomeScreen", (msg: string) => {
            GetApp("homescreen").open();
        });

        hub.on("transferUser", async () => {
            var success = await SP.post("/API/FormSubmit/Login?Handler=Transfer&TransferDeviceId=" + deviceId, null);
            if (success) {
                authenticated = true;
                if (devicePrefix == "ps")
                    await GetApp("app_pack_tote_list").open();
                else
                    await GetApp("homescreen").open();
                location.reload();
            }
        });

        hub.on("update_ui", (className: string, value: string) => {
            document.querySelectorAll("." + className).forEach((item) => {
                item.innerHTML = value;
            });
            console.log("updating " + className + " with value: " + value);
        });

        //hub.on("transferUser", TransferUser);

        //hub.on("signOut", LogOut);

        let _reconnecting = false;

        let registerDevice = async () => {
            var wms_deviceId = parseInt(localStorage.getItem("wms_deviceId") ?? "-1");
            console.log("RegisterDevice", wms_deviceId, 1);
            deviceId = await hub.connection.invoke("RegisterDevice", wms_deviceId, 1);
            SetDevice(deviceId);
        }

        hub.onDisconnect((error) => {
            if (!_reconnecting) {
                _reconnecting = true;
                console.log(error);
                StartLoading(true, true);
                console.log("DISCONNECTED");
            }
        });

        hub.onReconnected(async () => {
            if (_reconnecting) {
                //force reload current location app
                CloseAllApps();
                ignoreHashChange = false;
                await hashChanged();
                await registerDevice();
                StopLoading();
                console.log("RECONNECTED");
                _reconnecting = false;
            }
        });
        var settingsApp = (GetApp("app_settings") as App_Settings);
        hub.start(App_Settings.terminalSettings.transport, async () => {
            await registerDevice();

            if (!authenticated)
                GetApp("login").open();
            else {
                //load settings
                await settingsApp.loadUserSettings();
                var appKey = SP.getHash("app");
                var params = SP.getHashData();
                delete params["app"];
                if (appKey != null) GetApp(appKey).open(params);
                else GetApp("homescreen").open();
            }
        });

        ///Bind barcode commands
        barcodeListener.on("te", (terminalId) => {
            //temp do auto slave
            var id = parseInt(terminalId);
            SP.setAllHash({ "app": "app_slave", "parent": id.toString() });

            return;

            hub.connection.invoke("TransferLoginToTerminal", parseInt(terminalId)).then((result) => {
                if (result.success) {
                    LogOut();
                }
            });
        }, null);

        ///Bind barcode commands
        barcodeListener.on("ps", (terminalId) => {
            hub.connection.invoke("TransferLoginToTerminal", parseInt(terminalId)).then((result) => {
                var id = parseInt(terminalId);
                SP.setAllHash({ "app": "app_slave", "parent": id.toString() });
            });
        }, null);


        ///Bind barcode commands
        barcodeListener.on("a", (deviceId) => {
            var id = parseInt(deviceId);
            SP.setAllHash({ "app": "app_slave", "parent": id.toString() });
        }, null);


        barcodeListener.on("print", (data) => {
            selectPrinter(data);
        }, null);

        barcodeListener.on("lt", async (token) => {
            var loginApp = await GetApp("login") as login;
            await loginApp.open();
            (document.getElementById("login_username") as HTMLInputElement).value = "";
            (document.getElementById("login_password") as HTMLInputElement).value = token;
            await loginApp.LogIn();
        }, null);

        //fix touch problems

        container.addEventListener("touchmove", (e) => {
            // console.log("prevented default behaviour");
            //  e.preventDefault();
        });
        container.addEventListener("touchstart", (e) => {
            //console.log("prevented default behaviour");
            //e.preventDefault();
        });

        addItemAssistant = new AddItemAssistant();
        itemShortcutAssistant = new ItemShortcutAssistant();
        itemParkingAssistant = new ItemParkingAssistant();
        placementShortcutAssistant = new PlacementShortcutAssistant();
        placementFinderAssistant = new PlacementFinderAssistant();
        placementPickerAssistant = new PlacementPickerAssistant();
        toteAndPlacementPickerAssistant = new ToteAndPlacementPickerAssistant();
        toteAssistant = new ToteAssistant();
        itemSearchAssistant = new ItemSearcherAssistant();
        quickAuditAssistant = new QuickAuditAssistant();
        trolleyAssistant = new TrolleyAssistant();
        editLotAssistant = new EditLotAssistant();

        printerPickAssistant = new PrinterPickAssistant();
        container.appendChild(placementFinderAssistant.container);
        container.appendChild(addItemAssistant.container);
        container.appendChild(itemShortcutAssistant.container);
        container.appendChild(itemParkingAssistant.container);
        container.appendChild(placementShortcutAssistant.container);
        container.appendChild(placementPickerAssistant.container);
        container.appendChild(toteAndPlacementPickerAssistant.container);
        container.appendChild(printerPickAssistant.container);
        container.appendChild(toteAssistant.container);
        container.appendChild(itemSearchAssistant.container);
        container.appendChild(quickAuditAssistant.container);
        container.appendChild(trolleyAssistant.container);
        container.appendChild(editLotAssistant.container);

    }

    export function selectPrinter(data: string) {
        let name = data.split(":")[0];
        let labelFormat = data.split(":")[1];
        let current = labelFormat === "1" ? App_Settings.terminalSettings.etiquette_printer :
            labelFormat === "2" ? App_Settings.terminalSettings.a4_printer :
                App_Settings.terminalSettings.label_printer;

        if (current == name || name == "") return;

        if (labelFormat === "0") App_Settings.terminalSettings.label_printer = name;
        else if (labelFormat === "1") App_Settings.terminalSettings.etiquette_printer = name;
        else if (labelFormat === "2") App_Settings.terminalSettings.a4_printer = name;
        else {
            //set all
            App_Settings.terminalSettings.label_printer = App_Settings.terminalSettings.etiquette_printer = App_Settings.terminalSettings.a4_printer = name;
        }

        App_Settings.instance.saveSettings();
        DeviceLog.log("Changing printer to " + name);

        //talk
        var text = SP.Localize("sentance_now_using_printer") + " " + name;

        if (labelFormat === "0") text += ", " + SP.Localize("sentance_for_labels");
        else if (labelFormat === "1") text += ", " + SP.Localize("sentance_for_etiquettes");
        else if (labelFormat === "2") text += ", " + SP.Localize("sentance_for_a4");

        Talk(text);
    }

    export async function hashChanged() {
        if (ignoreHashChange) {
            ignoreHashChange = false;
            return;
        }
        console.log("Changed Hash, loading new page");
        var appKey = SP.getHash("app");
        var params = SP.getHashData();
        delete params["app"];
        if (appKey != null) await GetApp(appKey).open(params);
    }

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js?v=2', {
                scope: '/'
            })
                .then(registration => {
                    console.log("Service Worker registration completed ...");
                });
        });
    }

    //listen for hashchanges
    window.addEventListener("hashchange", () => {
        hashChanged();
    }, false);




    export class Input_Popup {
        container = document.createElement("div");
        headline = document.createElement("h1");
        input = document.createElement("input");
        btn = document.createElement("div");
        btn_close = document.createElement("div");
        btn_txt = document.createElement("span");
        action: () => void;

        get value() {
            return this.input.value;
        }

        set value(val) {
            this.input.value = val;
        }

        get open() {
            return this.container.style.display == "block";
        }

        constructor() {
            this.container.appendChild(this.headline);
            this.container.appendChild(this.input);
            this.container.appendChild(this.btn);
            this.btn.appendChild(this.btn_txt);

            this.btn_close.classList.add("close");
            this.btn_close.innerHTML = "X";
            this.btn_close.addEventListener("click", () => { this.hide(); });
            this.container.appendChild(this.btn_close);


            this.container.classList.add("input_popup")

            //style
            this.input.classList.add("full_input");
            this.btn.classList.add("btn", "grad-green")
            this.btn_txt.classList.add("text", "big", "center");


            this.btn.addEventListener("click", () => { this.execute(); });
            container.appendChild(this.container);
        }

        show(headline: string, buttonText: string, placeholder: string, action: () => void) {
            this.btn_txt.innerHTML = buttonText;
            this.headline.innerHTML = headline;
            this.input.placeholder = placeholder;
            this.input.value = '';
            this.action = action;
            this.container.style.display = "block";
        }

        hide() {
            this.container.style.display = "none";
        }

        execute() {
            if (this.action) this.action();
            this.hide();
        }

        setExecute(value: string) {
            this.input.value = value;
            this.btn.click();
        }

    }
    export let input_popup = new Input_Popup();
}

